import { FC } from "react";
import { observer } from "mobx-react";
import { DissolveCompanyForm } from "./dissolveCompanyDomain";
import { VBox } from "@/components-v2/Box";
import { useTranslation } from "@/stores/RootStoreContext";

export const DissolveCompanyView: FC<{ form: DissolveCompanyForm }> = observer(() => {
  const { t } = useTranslation();

  return (
    <VBox gap={"md"}>
      <div>
        <p className={"font-semibold"}>{t("decisions.dissolveCompany.decision.title")}</p>
        <p>{t("decisions.dissolveCompany.decision.text")}</p>
      </div>
      <div>
        <p className={"font-semibold"}>{t("decisions.dissolveCompany.votingRequirement.title")}</p>
        <p>{t("decisions.dissolveCompany.votingRequirement.text")}</p>
      </div>
      <div>
        <p className={"font-semibold"}>{t("decisions.dissolveCompany.whatHappensNext.title")}</p>
        <p>{t("decisions.dissolveCompany.whatHappensNext.registration")}</p>
      </div>
      <p>{t("decisions.dissolveCompany.whatHappensNext.boardObligations")}</p>
      <p>{t("decisions.dissolveCompany.whatHappensNext.finalSettlement")}</p>
    </VBox>
  );
});
